// Tarjetas Visa

const volar = {
  regional: [
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        'Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.',
        'Este plan no limita la disponibilidad en vuelos.',
        'Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.',
        '<a href="https://www.itauvolar.com.uy/volar/">Ver catálogo de millas Volar</a>',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Regional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        'Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra.',
      ],
    },
    {
      title: 'Millas por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realices con tu Itaú Visa Volar generará millas Itaú a excepción de los retiros de dinero en efectivo, cargos por intereses o cargos por parte del Banco (comisiones), ni consumos realizados en redes de cobranza (Abitab y RedPagos).',
      ],
    },
  ],
  internacional: [
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        'Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.',
        'Este plan no limita la disponibilidad en vuelos.',
        'Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.',
        '<a href="https://www.itauvolar.com.uy/volar/">Ver catálogo de millas Volar</a>',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Internacional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 2.500 millas',
      icon: 'star',
      content: [
        'Bono de 2.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra.',
      ],
    },
    {
      title: 'Millas por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realices con tu Itaú Visa Volar generará millas Itaú a excepción de los retiros de dinero en efectivo, cargos por intereses o cargos por parte del Banco (comisiones), ni consumos realizados en redes de cobranza (Abitab y RedPagos).',
      ],
    },
  ],
  oro: [
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        'Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.',
        'Este plan no limita la disponibilidad en vuelos.',
        'Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.',
        '<a href="https://www.itauvolar.com.uy/volar/">Ver catálogo de millas Volar</a>',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Oro Internacional requiere que nos envíes documentación. Esto significa que <strong>deberás que presentar documentación</strong> para que un vendedor se ponga en contacto contigo.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $60.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $60.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        'Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra.',
      ],
    },
    {
      title: 'Millas por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realices con tu Itaú Visa Volar generará millas Itaú a excepción de los retiros de dinero en efectivo, cargos por intereses o cargos por parte del Banco (comisiones), ni consumos realizados en redes de cobranza (Abitab y RedPagos).',
      ],
    },
    {
      title: 'Seguros',
      icon: 'lock',
      content: [
        'Por más información sobre seguros <a href="https://www.visa.com.uy/content/VISA/lac/spanishlanguagemaster/es_CO/home/pague-con-visa/tarjetas/credito/visa-gold.html">clic aquí</a>.',
      ],
    },
  ],
  platinum: [
    {
      title: 'Clientes preferenciales',
      icon: 'person',
      content: [
        'Itaú Visa Platinum es una tarjeta con beneficios exclusivos. Ofrece una muy amplia cobertura en viajes sin cargo para el titular y el grupo familiar.',
      ],
    },
    {
      title: 'Salas VIP',
      icon: 'vip',
      content: [
        `Descargá la app de Visa Airport Companion, para acceder a salas VIP en los aeropuertos, presentando el código QR luego de seleccionar la sala vip.
        <br />
        <br />
        Disponés de 10 accesos a USD 10 cada uno en el año calendario.
        <br />
        <br />
        Las tarjetas adicionales platinum también pueden ingresar descargando la app de Visa Airport Companion, y consumen de los 10 accesos a tarifa preferencial.
        <br />
        <br />
        Por encima de los 10 accesos la tarifa es de USD 32.`,
      ],
    },
    {
      title: 'Servicio de asistencia en viajes',
      icon: 'lock',
      content: [
        `<b>Cobertura brindada por AXA</b>
        <br />
        <br />
        Al comprar el pasaje de avión con tu Visa Platinum, recibirás de forma gratuita y en todo el mundo protección contra accidentes o emergencias médicas que ocurran fuera de tu país de residencia o del país donde se emitió tu tarjeta. La cobertura incluida es a través de AXA USA.
        <br />
        <br />
        El Servicio de Emergencia Médica Internacional te ofrece cobertura médica, hospitalaria y dental, válida para viajes internacionales de hasta 60 días consecutivos desde la fecha de salida de tu país de residencia. Para activar tu seguro es obligatorio generar el certificado de viaje antes de cada viaje elegible. Para ello precisas <a href="https://visabenefitslac.axa-assistance.us/benefits/I_D_UY/EMC_Emergency_Medical_Assistance_11" target="_blank">ingresar aquí</a>, crear un usuario y contraseña y completar la información solicitada. También podés hacerlo por la app Visa Benefits, previo registro con tu correo y contraseña.
        <br />
        <br />
        Para solicitar la asistencia a través de AXA deberás comunicarte con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf" target="_blank">clic aquí</a> para ver los números de teléfono.
        <br />
        <br />
        <b>Cobertura brindada por Universal Assistance</b>
        <br />
        <br />
        Por tener Visa Platinum, tenés incluido sin costo el servicio de asistencia de viaje en todo el mundo (excepto República Oriental del Uruguay) con Universal Assistance con una cobertura de hasta USD 15.000 por persona. El seguro te cubre a ti como titular de la tarjeta, cónyuges e hijos dependientes menores a 21 años.
        <br />
        <br />
        Prestaciones: Asistencia médica, odontológica, jurídica y localización de equipaje.
        <br />
        <br />
        Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. <a href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf" target="_blank">Ver condiciones</a>
        <br />
        <br />
        (*) Los seguros de asistencia en viajes no son acumulables.`,
      ],
    },
    {
      title: 'Primera adicional sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. A partir de la segunda adicional se cobra el 50% del costo de la tarjeta.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        `La tarjeta Visa Regional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <b>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo.</b> Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.`,
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas, y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        'Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra. El bono se acredita junto con las millas generadas en el primer estado de cuenta.',
      ],
    },
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        `Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.
        <br />
        <br />
        Este plan no limita la disponibilidad en vuelos.
        <br />
        <br />
        Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.
        <br />
        <br />
        <a href="https://www.itauvolar.com.uy/volar/" target="_blank">Conocer catálogo de millas Volar</a>`,
      ],
    },
  ],
  infinite: [
    {
      title: 'Clientes preferenciales',
      icon: 'person',
      content: [
        ' Itaú Visa Infinite es la primera tarjeta de estas características en el Uruguay, pensada especialmente para clientes preferenciales. ',
        ' Brinda reconocimiento y prestigio mundial junto con los mejores beneficios y servicios disponibles en la industria de medios de pago. Ofrece una muy amplia cobertura en viajes sin cargo para el titular y el grupo familiar. ',
      ],
    },
    {
      title: 'Priority Pass',
      icon: 'vip',
      content: [
        ' Los titulares de la tarjeta Visa Platinum e Infinite de Itaú reciben junto con ésta la tarjeta Priority Pass. La misma permite ser parte del programa independiente de acceso a salas VIP de aeropuertos más amplio del mundo. ',
        ' La tarjeta Priority Pass te brinda 7 accesos gratis al año (calendario). A partir del octavo acceso, se cargará a la tarjeta de crédito del titular cada acceso adicional a USD 27. ',
        'Para ver la lista de Salas Vip adheridas y bases y condiciones hacé <a target="_blank" href="https://www.prioritypass.com/en/airport-lounges">click aquí</a>.',
      ],
    },
    {
      title: 'Servicio de asistencia médica en Viaje: Cobertura brindada por Universal Assistance',
      icon: 'lock',
      content: [
        '<strong>Área de Cobertura:</strong> Todo el mundo (excepto la República Oriental del Uruguay).',
        '<strong>Beneficiarios:</strong> Tarjeta habientes, cónyuges e hijos dependientes menores de 21 años.<p><strong>Prestaciones:</strong> Asistencia Médica, Odontológica, Jurídica y Localización de Equipaje.',
        'Los beneficiarios cuentan con el Servicio de Asistencia en Viajes que brinda Universal Assistance de hasta USD 15.000 por persona.',
        'Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido.',
        '<a target="_blank" href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf">Ver condiciones</a>',
      ],
    },
    {
      title: 'Cobertura brindada por AXA USA',
      // icon: 'money-circle',
      content: [
        'Además, si se abona el pasaje de avión con Itaú Visa Platinum, cuentan con la siguiente cobertura a través de AXA USA (*).<p>Asistencia en Viajes de hasta un máximo de USD 100.000 en todo el mundo.',
        '<strong>Beneficiarios:</strong> titular, cónyuge e hijos menores de 23 años.',
        '<strong>(*)</strong> Los seguros de Asistencia en Viajes no son acumulables.',
        '<strong>(**)</strong> Países firmantes del tratado Schengen.',
        'Para solicitar la asistencia a través de AXA siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a target="_blank" href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf">click aquí</a> para ver los números de teléfono.',
      ],
    },
    {
      title: 'Seguros',
      // icon: 'more',
      content: [
        'Por más información sobre seguros <a target="_blank" href="https://www.visa.com.uy/pague-con-visa/tarjetas/credito/visa-infinite.html">clic aquí</a>.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        ' La tarjeta Visa Volar Infinite requiere que nos envíes documentación. Esto significa que deberás que presentar documentación para que un vendedor se ponga en contacto contigo. ',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        'Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra.',
      ],
    },
    {
      title: 'Visa Luxury Hotel Collection',
      icon: 'building',
      content: [
        'Los clientes de Visa Infinite tienen acceso a un programa de beneficios exclusivos en los más prestigiosos hoteles del mundo.',
      ],
    },
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        'Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.',
        'Este plan no limita la disponibilidad en vuelos.',
        'Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.',
        '<a target="_blank" href="https://www.itauvolar.com.uy/volar/">Ver catálogo de millas Volar</a>',
      ],
    },
  ],
};

export default volar;
